module.exports = __webpack_public_path__ + "img/booking-03.02675779.png";